import { motion } from "motion/react";
import { useId } from "react";
import { cn } from "@/lib/cn";
import { spring } from "@/lib/motion";

interface Props<T extends string> {
  value: T;
  onChange: (v: T) => void;
  options: { value: T; label: string }[];
  className?: string;
  size?: "sm" | "md";
}

export function SegmentedControl<T extends string>({
  value,
  onChange,
  options,
  className,
  size = "md",
}: Props<T>) {
  const id = useId();
  return (
    <div
      role="radiogroup"
      className={cn("relative flex rounded-[10px] bg-surface-2 p-0.5", className)}
    >
      {options.map((o) => {
        const active = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(o.value)}
            className={cn(
              "relative flex-1 rounded-[8px] px-2 font-medium whitespace-nowrap transition-colors",
              size === "sm" ? "py-1 text-footnote" : "py-1.5 text-subhead",
              active ? "text-text" : "text-muted",
            )}
          >
            {active && (
              <motion.span
                layoutId={`seg-${id}`}
                transition={spring.snappy}
                className="absolute inset-0 rounded-[8px] bg-surface shadow-[0_1px_4px_rgba(0,0,0,0.12)] dark:bg-[#636366]"
              />
            )}
            <span className="relative">{o.label}</span>
          </button>
        );
      })}
    </div>
  );
}
